<template>
<div style="height: 100%;">
   <cover-photo-modal/>

    <canvas ref="canvass" id="canvass" class="text-center"  @click="clickEventFIre"></canvas>

    <div class="pointer" :style="{ top: `${boxXY.y - 35}px` , left: `${boxXY.x - 50}px`    }" id="moveid" ref="moveid" v-if="pointBox">
            <div class="pointer-box">
               <div class="pointer-b"><span class="float-left pb-h1 pl-2 pt-1">Koordinaten:</span>
               <span class="float-right" @click="deletePointer">
                 <img src="@/assets/images/delete.png" alt="img">
               </span>
               </div>
               <div class="pointer-b pb-4">
                 <label class="float-left pl-2 pt-1">Latitude</label>
               <span class="float-right p2-txt">
               <input type="text"  v-model="mapLat" class="form-control-sm sm-input3" id="pointer-box1" value="1.234" placeholder="" @input="val => mapLat = val.target.value.replace(/,/g, '.').replace(/\s/g, '')" ></span></div>
               <div class="pointer-b">
                 <label class="float-left pl-2 pt-1">Longitude</label>
               <span class="float-right p2-txt">
               <input type="text" v-model="mapLng" class="form-control-sm sm-input3" id="pointer-box2" value="1.234" placeholder="" @input="val => mapLng = val.target.value.replace(/,/g, '.').replace(/\s/g, '')" ></span>
               </div>
               <div class="pointer-b">
               <button type="button" class="btn btn-light mode-pd12 mr-2 d-none" @click="showPictures">Fotodaten verwenden</button>
               <button type="button" @click="showMaps()" id="google-mapBtn" class="btn btn-light mode-pd12 ml-2">Google Maps verwenden</button>
                 <img v-if="coverImage" :src="coverImage" class="ml-4 rounded Picture_Window_Canvas" alt="cover-image" width="50">
               </div>
               <div class="pointer-b text-right">
               <button type="button"  @click="savePoint()"  class="btn btn-light ok-btn radius-20">Ok</button>
               </div>
            </div>
         </div>
  </div>

</template>

<script>
import {fabric} from 'fabric'
import CoverPhotoModal from '../photoDocumentation/components/PhotoDetails/CoverPhotoModal'

export default {
  name: 'canvasView',
  props: ['showPlan', 'markersList','is_edit_active'],
  data () {
    return {
      resized: false,
      initialTouchDistance: null,
      initialZoom: null,
      counter: 0,
      mapLat: 0,
      mapLng: 0,
      can: null,
      canvas: null,
      pointDragTrue: false,
      newPointer: 1,
      pointBox: false,
      coadinates: {x: 200, y: 350},
      boxXY: {x: 370, y: 372},
      container: {width: 750, height: 750},
      images: [],
      lastZoom: 0,
      currentPin: '',
      pinIDs: 1,
      isMapMoving: false,
      currentX: '',
      currentY: '',
      xChange: '',
      yChange: '',
      lastX: 0,
      lastY: 0,
      image: null,
      tempWidth: 770,
      tempHeight: 450,
      plPercent: 100,
      ptPercent: 100,
      h_dif: 0,
      w_dif: 0,
      activePoint: null,
      offset_top: 0.0,
      offset_left: 0.0
    }
  },
  mounted () {
    let _this = this
    _this.setBackgroundImage()
    _this.movediv()
    $(window).resize(function () {
      if(_this.is_edit_active) {
        console.log(_this.is_edit_active)
        _this.resized = true
      } else {
        _this.setBackgroundImage()
        _this.resized = false
      }
      // _this.zoomIn(_this.$parent.zoomRange)
    })
  },
  components: {
    CoverPhotoModal
  },
  computed: {
    coverImage: function () {
      return this.$store.state.photoDocumentation.coverPhoto
    },
    planPhoto: function (){
      return this.$store.state.plans.planImage
    }
  },
  methods: {
     calculatePositionOnCanvas (xcoord, ycoord , img) {
      let ow = this.offset_left
      let iw = img.width
      let ih = img.height
      let hdif = this.h_dif
      let wdif = this.w_dif

      let x = (((xcoord + (iw / 2)) / 100) * wdif) + ow
      let y = (((ycoord + (ih / 2)) / 100) * hdif) + this.offset_top
      return {x: x, y: y}
    },


    showPictures () {
      $('.pointer-box').css('visibility', 'hidden')
      $('#photosModal').modal('toggle')
      $('div#simple_photo_checkbox #mySidenav').css('left', '0')
    },
    // TODO CheckPointer
    checkSetPointer () {
      const PointerValue = localStorage.getItem('Pointercounter')
      if (PointerValue == null || PointerValue == 0) {
        $('.delete_pointer').prop('disabled', true)
      } else {
        $('.delete_pointer').prop('disabled', false)
      }
    },

    zoomIn (range) {
      let _this = this
      let c = (range / 50) + 1
        this.canvas.zoomToPoint({ x: _this.canvas.getWidth() / 2, y: _this.canvas.getHeight() / 2 }, c)
        this.canvas.setZoom(c)
      // On zoom Reduce the radius of pointers
      this.canvas.getObjects().forEach(function (obj) {
        _this.setPointsZoom(range, obj)
      })
    },

    setPointsZoom (range, obj) {
      obj.set({
        radius: 5.5,
        strokeWidth: 5 / 2
      })
      let r = (1500 / range) * 0.125
      if (range <= 25) {
        obj.set({
          radius: 3.9,
          strokeWidth: 3.5 / 2
        })
      } else if (range < 60 && range >= 25) {
        if (r > 3.47) {
          obj.set({
            radius: 3.46,
            strokeWidth: 3.40 / 2
          })
        }
      } else if (range > 400) {
        obj.set({
          radius: 0.495,
          strokeWidth: 0.49 / 2
        })
      } else {
        obj.set({
          radius: r,
          strokeWidth: r / 2
        })
      }
    },

    zoomOut () {
      this.canvas.setZoom(this.canvas.getZoom() / 1.1)
    },

    showMaps () {
      $('#map-model').modal('toggle');
      // this.$parent.showMaps()
    },

    savePoint () {
      this.canvas.getObjects().forEach(item => {
        if (item.data.index === this.activePoint.data.index) {
          item.data.lat = this.mapLat
          item.data.lon = this.mapLng
        }
      });
      this.pointBox = false
      if(this.resized) {
        this.setBackgroundImage()
      }
    },

    clickEventFIre: function () {
      // console.log('clicekd');
    },
    movediv: function () {
      $('.delete_pointer').prop('disabled', false)
      // let elmnt = this.$refs.moveid;
      this.boxXY.x = (this.container.width / this.canvas.width * (this.coadinates.y)) - 100 + 'px'
      this.boxXY.y = (this.container.height / this.canvas.height * (this.coadinates.x)) - 100 + 'px'
      this.markersList[0].coadinates.x = ((this.coadinates.x / this.canvas.width) * this.images.width) - (this.images.width / 2)
      this.markersList[0].coadinates.y = (((this.coadinates.y / this.canvas.height) * this.images.height) - (this.images.height / 2))
    },

    setPonter (allow = false) {
      const _this = this
      const last_ref_point = _this.showPlan.refpoints[_this.showPlan.refpoints.length - 1]
      let index = _this.canvas.getObjects().length + 1;
      let range = _this.$parent.zoomRange
      this.newPointer = 1
      let data = {
        index: index,
        lat: last_ref_point ? (last_ref_point.lat + 0.00055) : 51.420250,
        lon: last_ref_point ? last_ref_point.lon : 6.835990,
        x: 0,
        y: 0,
        _explicitType: "com\\projectdocu\\RefPointVO"
      }
      const can_width = (_this.canvas.width + (_this.showPlan.refpoints.length * 25))
      _this.showPlan.refpoints.push(data);
      //Draw points on canvas
      const obj = _this.createRefPoint(data)
      _this.canvas.add(obj.set({
        left: can_width / 2,
        top: _this.canvas.height / 2
      }))

      _this.addEventsOnRefPoints(obj);
      _this.setPointsZoom(range, obj)
      _this.canvas.setActiveObject(obj)
      _this.pinIDs++
      _this.canvas.renderAll()
    },

    addEventsOnRefPoints(obj){
       let _this = this
      obj.on('mousedblclick', function (e) {
        _this.pointBox = false
        _this.activePoint = e.target;
        _this.boxXY.y = _this.canvas.getPointer(event).y
        _this.boxXY.x = _this.canvas.getPointer(event).x
        _this.mapLat = parseFloat(_this.activePoint.data.lat)
        _this.mapLng = parseFloat(_this.activePoint.data.lon)
        _this.$parent.mapCentre = { lat: _this.mapLat, lng: _this.mapLng }
        _this.$parent.mapLatLong = { lat: _this.mapLat, lng: _this.mapLng }
        _this.$parent.prevLatLng = { lat: _this.mapLat, lng: _this.mapLng }
        _this.pointBox = true
      })
      //when point moved update its position in data
      obj.on('mouseup', function (e) {
        if (_this.$parent.editTabShow) {
          _this.pointDragTrue = false
        }
        let coords = {'x': _this.canvas.getPointer(event).x, 'y': _this.canvas.getPointer(event).y}
        e.target.data.x = (((coords.x - _this.offset_left) / _this.w_dif) * 100) - (_this.image.width / 2)
        e.target.data.y = (((coords.y - _this.offset_top) / _this.h_dif) * 100) - (_this.image.height / 2)
      })
      obj.on('mousedown', function (e) {
        if (_this.$parent.editTabShow) {
          _this.pointDragTrue = true
        }
      })
      obj.on('moving', function (e) {
        // if (_this.pointDragTrue === true) {
        //   _this.coadinates = {'x': _this.canvas.getPointer(event).x, 'y': _this.canvas.getPointer(event).y}
        //
        //   _this.boxXY.x = (parseInt(Math.round(event.y - _this.canvas._offset.top))) + 'px'
        //   _this.boxXY.y = (parseInt(Math.round(event.x - _this.canvas._offset.left))) + 'px'
        //
        //   // update the current or new array for multiple moving pins
        //   if (e.target.id) {
        //     let currentPositionX = parseInt(_this.canvas.getPointer(event).x)
        //     let currentPositionY = parseInt(_this.canvas.getPointer(event).y)
        //
        //     // Calculation of Points Position Value according to screen size
        //     let x = (currentPositionX / _this.plPercent) * 100
        //     let y = (currentPositionY / _this.ptPercent) * 100
        //
        //     let tab = parseInt(e.target.id)
        //     _this.$parent.editPlan.georefpoints[tab - 1].y = parseInt(y)
        //     _this.$parent.editPlan.georefpoints[tab - 1].x = parseInt(x)
        //   }
        //   // end updation
        // }
      })

    },

    /**Method to make a pointer
     *
     * @returns {*}
     */
    createRefPoint(item){
     return  new fabric.Circle({
        fill: '',
        hasBorder: true,
        stroke: 'red',
        strokeWidth: 5,
        originX: 'middle',
        originY: 'middle',
        data: item,
        hasControls: false,
        selection: false,
        allowTouchScrolling: true,
        hasBorders: true,
        hoverCursor: 'default',
      })
    },

   async drawPonter (showplan) {
      let _this = this
      let range = _this.$parent.zoomRange
      this.geoRefUpdated = []
      let resPoints = showplan.refpoints;
      await  resPoints.forEach(function (item , index) {
          item.index = (index + 1)
        let coords = _this.calculatePositionOnCanvas(item.x , item.y ,_this.image)
          //draw pointer on canvas plan image
          let obj = _this.createRefPoint(item);
          _this.canvas.add(obj.set({
            left: coords.x,
            top: coords.y
          }));
          _this.setPointsZoom(range, obj)

          _this.pinIDs++
          // add events on ref points
          _this.addEventsOnRefPoints(obj);
          _this.canvas.renderAll()
        })
      let val = _this.canvas.getZoom() + 0.05
      this.canvas.zoomToPoint({ x: this.canvas.getWidth() / 2, y: this.canvas.getHeight() / 2 }, val)
      _this.canvas.setZoom(val)
    },



    setBackgroundImage: async function () {
      this.pointBox = 0
      const ref = this.$refs.canvass
      if (!(this.canvas === null || this.canvas === undefined)) {
        this.canvas.clear()
        this.canvas.dispose()
      }
      const canvas = new fabric.Canvas(ref, {
          selection: false,
          controlsAboveOverlay: true,
          centeredScaling: true,
          allowTouchScrolling: true,
          hasBorders: false,
          lockRotation: false,
          lockMovement: false,
          enableRetinaScaling: true,
          lockMovementY: false,
          lockMovementX: false,
          lockUniScaling: false,
          lockScalingY: false,
          lockScalingX: false,
          originX: 'middle',
          originY: 'middle',
          isDrawingMode: false,
          preserveObjectStacking: false
        })
      this.canvas = canvas
      let _this = this

      await  fabric.Image.fromURL(this.planPhoto, function (img) {
        let hgt = document.querySelector('.screen-height').offsetHeight;
        let canvas_width = document.getElementById('canvas_box').offsetWidth

        let hPer = (hgt / img.height) * 100
        let width = (img.width / 100) * hPer

        if ( width > canvas_width ) {
          let wdh_difference = width - canvas_width
          let w_dif_per = (wdh_difference / width) * 100
          let cal_hgt = hgt / 100 * w_dif_per
          hgt = hgt - cal_hgt;
          width = canvas_width
        }

        let hPerForOffset = (hgt / img.height) * 100
        let widthForOffset = (img.width / 100) * hPerForOffset
        _this.offset_left = (canvas_width - widthForOffset) / 2

        let image_height = document.querySelector('.screen-height').offsetHeight;
        let widthForOffsetTop = (width / img.width) * 100
        let heightForOffsetTop = (img.height / 100) * widthForOffsetTop
        _this.offset_top = (image_height - heightForOffsetTop) / 2
        canvas.setHeight(hgt)
        canvas.setWidth(width)

        _this.image = img
        _this.images.height = img.height
        _this.images.width = img.width

        _this.h_dif = (hgt / img.height) * 100
        _this.w_dif = (width / img.width) * 100


        canvas.setBackgroundImage(img, canvas.renderAll.bind(canvas), {
          centeredRotation: true,
          centeredScaling: true,
          originX: 'middle',
          originY: 'middle',
          backgroundImageStretch: true
        })

        img.set({
          centeredRotation: true,
          centeredScaling: true,
          originX: 'middle',
          originY: 'middle',
          scaleX: canvas.width / img.width,
          scaleY: canvas.height / img.height
        })
        _this.$parent.zoomOut()
        canvas.renderAll()

        canvas.setWidth(canvas_width);
        const div_height = document.querySelector('.screen-height').offsetHeight;
        canvas.setHeight(div_height);
        canvas.centerObject(img)
        _this.$parent.zoomRange = 7
      })

      _this.canvas.on('mouse:wheel', function (opt) {
        _this.pointBox = false
        if (opt.e.deltaY > 0) {
          _this.$parent.zoomOut()
        } else {
          _this.$parent.zoomIn()
        }
      })

      let panning = false
      canvas.on('mouse:up', function (e) {
        panning = false;
        _this.lastX = _this.lastY = null;
      })
      canvas.on('touch:start', (e) => {
        // Reset the lastX and lastY properties
        _this.lastX = _this.lastY = null;
      });
      canvas.on('touch:end', () => {
        _this.lastX = _this.lastY = null;
        _this.initialZoom = _this.initialTouchDistance = null;
      });

      canvas.on('mouse:down', function (e) {
        panning = true;
        _this.lastX = _this.lastY = null;
      });

      canvas.on('object:moving', function (e) {
        panning = false
      });

      canvas.on('object:scaling', function (e) {
          console.log('we are zoomed')
        });


// Add event listeners to the canvas to handle touch events
      canvas.on('touch:gesture', function (e) {
        console.log("any thing is here gesture",e)
        if (e.e.touches && e.e.touches.length === 2) {
          const newScale = canvas.getZoom() * e.e.scale;
          canvas.zoomToPoint({ x: e.pointer.x, y: e.pointer.y }, newScale);
        }
      });

      canvas.on('touch:drag', function (event) {
        let pointer = canvas.getPointer(event.e);
        canvas.setCursor('move');
        canvas.renderAll();
        canvas.relativePan(new fabric.Point(pointer.x - event.absolutePointer.x, pointer.y - event.absolutePointer.y));
      });

      this.canvas.on('mouse:move', function (e) {
        if (panning && e && e.e) {
          if (_this.pointDragTrue === false && e.e.type === 'mousemove') {
              const delta = new fabric.Point(e.e.movementX, e.e.movementY)
              canvas.relativePan(delta)
              const canvasViewPort = canvas.viewportTransform
              const bottomEndPoint = canvas.height * (canvasViewPort[0] - 1)
              if (canvasViewPort[5] >= 0 || -bottomEndPoint > canvasViewPort[5]) {
                canvasViewPort[5] = (canvasViewPort[5] >= 0) ? 0 : -bottomEndPoint
              }
              const rightEndPoint = canvas.width * (canvasViewPort[0] - 1)
              if (canvasViewPort[4] >= 0 || -rightEndPoint > canvasViewPort[4]) {
                canvasViewPort[4] = (canvasViewPort[4] >= 0) ? 0 : -rightEndPoint
              }
          }else if (e.e.touches && e.e.touches.length === 1){
            _this.touchMoveEvent(e.e.touches[0])
          }else if (e.e.touches && e.e.touches.length === 2) {
            // Save the initial touch distances when the touch action starts
            if (!_this.initialTouchDistance) {
              _this.initialTouchDistance = Math.hypot(
                e.e.touches[0].clientX - e.e.touches[1].clientX,
                e.e.touches[0].clientY - e.e.touches[1].clientY
              );
              _this.initialZoom = canvas.getZoom();
            }
            // Calculate the current touch distance
            const currentTouchDistance = Math.hypot(
              e.e.touches[0].clientX - e.e.touches[1].clientX,
              e.e.touches[0].clientY - e.e.touches[1].clientY
            );
            // Calculate the new zoom level based on the initial and current touch distances
            const newScale = _this.initialZoom * (currentTouchDistance / _this.initialTouchDistance);
            // Find the center point between the two touches
            const centerX = (e.e.touches[0].clientX + e.e.touches[1].clientX) / 2;
            const centerY = (e.e.touches[0].clientY + e.e.touches[1].clientY) / 2;
            // Convert the center point to canvas coordinates
            const pointer = canvas.getPointer({ clientX: centerX, clientY: centerY });
            // Zoom the canvas
            canvas.zoomToPoint({ x: pointer.x, y: pointer.y }, newScale);
          }
        }
      });

      this.newPointer = 0
    },

    touchMoveEvent(touch){
      if (this.lastX && this.lastY) {
        const delta = new fabric.Point(touch.clientX - this.lastX, touch.clientY - this.lastY)
        this.canvas.relativePan(delta)
        const canvasViewPort = this.canvas.viewportTransform

        const bottomEndPoint = this.canvas.height * (canvasViewPort[0] - 1)
        if (canvasViewPort[5] >= 0 || -bottomEndPoint > canvasViewPort[5]) {
          canvasViewPort[5] = (canvasViewPort[5] >= 0) ? 0 : -bottomEndPoint
        }
        const rightEndPoint = this.canvas.width * (canvasViewPort[0] - 1)
        if (canvasViewPort[4] >= 0 || -rightEndPoint > canvasViewPort[4]) {
          canvasViewPort[4] = (canvasViewPort[4] >= 0) ? 0 : -rightEndPoint
        }
      }
      this.lastX = touch.clientX;
      this.lastY = touch.clientY;
    },

    deletePointer () {
      // push id in deleted pins array
      let activePoint = this.canvas.getActiveObject();
      let ref_point = activePoint.data;
      if (activePoint) {
        this.canvas.remove(activePoint)
        this.newPointer = 0;
        this.pointBox = 0;
        this.showPlan.refpoints = this.showPlan.refpoints.filter(item => item.index !== ref_point.index)
      }
    },

    async removeAllPoints () {
      let canvas = this.canvas
      if(canvas) {
        await canvas.remove(...canvas.getObjects())
        await canvas.renderAll()
      }
    },
  },
  watch: {
    is_edit_active: function() {
      if(this.resized) {
        this.setBackgroundImage();
      }
    },
    planPhoto: async  function () {
      $('.spinner-cover').show();
     await this.setBackgroundImage();
      $('.spinner-cover').hide();
    },
    coadinates: function () {
      // this.movediv();
      // console.log(this.coadinates);
    }
  }

}

</script>
<style>
  .canvas-container{
    margin: auto;
    min-height: 100%;
  }

  #canvass{
    /*min-height: 100% !important;*/
    left: 0;
    right: 0;
    margin-left: auto;
    margin-right: auto;
  }

  #panzoom #canvass{
    max-width : 100% !important;
    min-height: 100% !important;
  }

  /*canvas{*/
  /*  max-height: 100%;*/
  /*}*/
  /*canvas {*/
  /*  background-size: 100% 100%;*/
  /*}*/
</style>



// WEBPACK FOOTER //
// src/components/plan/Canvas.vue